import styled from "styled-components";
import clear from 'assets/searchbar/clear.svg'
import Button from "../Button";

export const Container = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;

  padding-left: 13px;
  padding-right: 35px;
  border-radius: 8px;
  height: ${({theme}) => theme.old.sizes.button.medium};
  background-color: ${({theme}) => theme.old.colors.gray[275]};
  
  ${({ theme }) => theme.old.breakpoints.isTab} {
    border-radius: 6px;
  }

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    max-height: 32px;
  }
`

export const Input = styled.input`
  background-color: transparent;
  height: 100%;
  color: ${({ theme }) => theme.old.colors.white};
  border: none;
  width: 100%;
`

export const ClearBtn = styled(Button)`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);

  background-image: url(${clear});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 17px;
  height: 25px;

  background-color: transparent;
  box-shadow: none;
  transition: none;

  :hover, :active {
    background-color: transparent;
    box-shadow: none;
  }
`